import { MutationTuple, useMutation } from '@apollo/client';

import { CombineContributorMutation, CombineContributorMutationVariables, COMBINE_CONTRIBUTOR } from '@neo.tax/shared';

type UseCombineContributor = MutationTuple<CombineContributorMutation, CombineContributorMutationVariables>;

export const useCombineContributor = (): UseCombineContributor =>
  useMutation<CombineContributorMutation, CombineContributorMutationVariables>(COMBINE_CONTRIBUTOR, {
    context: {
      successToast: {
        title: 'Contributors successfully merged',
      },
      errorToast: {
        title: 'Cannot merge contributors',
        description:
          'These contributors have conflicting payroll data for the same month(s). Please contact support to resolve this issue.',
      },
    },
  });
